import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import "bootstrap/dist/css/bootstrap.min.css";
// initialize firebase

const firebaseConfig = {
    apiKey: "AIzaSyAP0YPq7g0_q-WfR7PXc-YPaU_mzhpLh9M",
    authDomain: "react-meetup-4db79.firebaseapp.com",
    databaseURL: "https://react-meetup-4db79-default-rtdb.firebaseio.com",
    projectId: "react-meetup-4db79",
    storageBucket: "react-meetup-4db79.appspot.com",
    messagingSenderId: "820826931597",
    appId: "1:820826931597:web:954b04dd6d884540f57dc4",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
